module.exports = __webpack_public_path__ + "static/media/audio.6ab1eb73.mp3";